// extracted by mini-css-extract-plugin
module.exports = {"header":"_3AxWq5qXuWtLneysNEoxFW","backoffice":"_3gboL2b8DDOc4VEFtebAoD","body":"UOcQumCn48cTR_uD7ytOT","sepDiv":"WRseusMuTLEn4Cv0XZXsT","breadcrumbLink":"Iner-tQ1D0fVHzH1Cxbu-"};